// extracted by mini-css-extract-plugin
export default {"wrapper":"Statistics_wrapper__yh65z"};